import React from 'react'
import TableMui from 'src/components/TableMui'
import { Divider, FormControlLabel } from '@mui/material'
import { TableMuiLabel } from 'src/components/TableMui/styles'
import {
  InvoiceDetail,
  PendingReceivementConference,
  ProductWrong,
} from '../../../PendingReceivementsTypes'
import {
  CorrectQtyPerBoxButton, TableFooter, TableFooterRow, CustomTooltip,
} from './ReceivementConferenceTables.style'
import { resolveTableFooter } from './ReceivementConferenceTables.utils'
import { EditQtyPerBoxModal } from './EditQtyPerBoxModal'
import { ConfirmCheckbox } from 'src/features/supplier/components/PrintInvoicesSection/ConfirmPrintsBody/ConfirmPrintsBody.style'
import { useSelector } from 'src/utils/store'
import { useDispatch } from 'react-redux'
import { actions } from 'src/features/pending-receivements/PendingReceivementsState'

interface ReceivementConferenceTablesProps {
  receivementConference?: PendingReceivementConference[]
  wrongProducts?: ProductWrong[]
}

export const ReceivementConferenceTables = ({ receivementConference, wrongProducts }: ReceivementConferenceTablesProps) => {
  const dispatch = useDispatch()

  const [editModalIsOpen, setEditModalIsOpen] = React.useState(false)
  const [currentReceivementToEdit, setCurrentReceivementToEdit] = React.useState<PendingReceivementConference>()
  const approveCheckboxesValues: Record<number, boolean> = useSelector((state) => state.pendingReceivements.approveCheckboxesValues)

  const openEditModal = (receivement: PendingReceivementConference) => {
    setCurrentReceivementToEdit(receivement)
    setEditModalIsOpen(true)
  }

  const handleCheck = async (event: React.ChangeEvent<HTMLInputElement>, index: number) => {
    dispatch(actions.setApproveCheckboxesValues({ ...approveCheckboxesValues, [index]: event.target.checked }))
  }

  const getRows = (details: InvoiceDetail[]) => (details.map((detail) => {
    if (!details) return []

    const expectedQuantityRow = detail.qtyPerBox * detail.boxQuantity

    return {
      ...details,
      idAr: detail.idAr,
      qtyPerBox: `${detail.qtyPerBox} ${detail.measureUnit}`,
      boxQuantity: detail.boxQuantity,
      expectedQuantity: `${expectedQuantityRow} ${detail.measureUnit}`,
      buyer: detail.buyer,
      invoiceChecker: detail.invoiceChecker,
    }
  }))

  const disableQuantityPerBoxCorrection = () => {
    if (wrongProducts?.length === 0) return false

    const allWrongProductsResolved = wrongProducts?.every((product) => product.wrongProductConfirmed === true)

    if (allWrongProductsResolved) return false

    return true
  }

  const receivementConferenceWithoutFlv = receivementConference?.filter((receivement) => !receivement.isFlv)

  return (
    <>
      {receivementConferenceWithoutFlv?.map((receivement: PendingReceivementConference, index: number) => (
        <TableMui
          key={receivement.modelId}
          columns={[
            { id: 'idAr', label: 'AR', width: '25%' },
            { id: 'qtyPerBox', label: 'Caixaria', width: '25%' },
            { id: 'boxQuantity', label: 'Qtd. Caixas', width: '25%' },
            { id: 'expectedQuantity', label: 'Qtd. Esperada', width: '25%' },
          ]}
          rows={getRows(receivement.invoiceDetails)}
          columnsStyle={{ padding: 8 }}
          tableLabel={(
            <TableMuiLabel data-testid='receivement-to-check-label'>
              {`${receivement.modelId} - Cód. Produto: ${receivement.codProduto} - ${receivement.productDescription}`}
            </TableMuiLabel>
        )}
          tableFooter={(
            <TableFooter>
              <TableFooterRow>{resolveTableFooter(receivement.invoiceDetails)}</TableFooterRow>
              <Divider />
              <TableFooterRow>
                <CustomTooltip
                  arrow
                  title={disableQuantityPerBoxCorrection() ? 'Resolva os produtos errados antes de corrigir caixaria' : ''}
                >
                  <div>
                    <CorrectQtyPerBoxButton
                      variant='outlined'
                      onClick={() => openEditModal(receivement)}
                      data-testid='correct-qty-per-box-button'
                      disabled={disableQuantityPerBoxCorrection()}
                    >
                      Corrigir caixaria
                    </CorrectQtyPerBoxButton>
                  </div>
                </CustomTooltip>
                <FormControlLabel data-testid='approve-checkbox' control={<ConfirmCheckbox onChange={(event) => handleCheck(event, index)} />} label='Aprovar' />
              </TableFooterRow>
            </TableFooter>
          )}
          includeTooltipInto='idAr'
          tooltipContent={[
            { id: 'buyer', label: 'Comprador' },
            { id: 'invoiceChecker', label: 'Conferente' },
          ]}
          thinLine
        />
      ))}
      {editModalIsOpen && (
        <EditQtyPerBoxModal
          modalIsOpen={editModalIsOpen}
          setModalIsOpen={setEditModalIsOpen}
          receivementToEdit={currentReceivementToEdit}
        />
      )}
    </>
  )
}
